import { render, staticRenderFns } from "./AccountDrawMoney.vue?vue&type=template&id=23abf91b&scoped=true&"
import script from "./AccountDrawMoney.vue?vue&type=script&lang=js&"
export * from "./AccountDrawMoney.vue?vue&type=script&lang=js&"
import style0 from "./AccountDrawMoney.vue?vue&type=style&index=0&id=23abf91b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abf91b",
  null
  
)

export default component.exports